import React from "react";
import TextInput from "../../../components/elements/form/TextInput";
import { getCompanyRCNumber } from "../../../service/api/company";
import { useAppDispatch, useAppSelector } from "../../../store";
import { ITextInputErrorWarning } from "../../../store/@types/misc";
import { FaArrowRightLong } from "react-icons/fa6";

type IGetRCNumber = {
  getRCNumber: (data: { rc_number: string }) => void;
};

const GetRCNumber: React.FC<IGetRCNumber> = ({ getRCNumber }) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ company }) => company.loading);

  const [data, dataSet] = React.useState<{ rc_number: string }>({
    rc_number: "",
  });
  const [error, errorSet] = React.useState<ITextInputErrorWarning>("");

  const onSubmit = () => {
    if (!data.rc_number) {
      errorSet("warning");
      return;
    }
    getCompanyRCNumber(dispatch, { rc_number: data.rc_number });
    getRCNumber(data);
  };

  return (
    <TextInput
      type="text"
      label="RC NUMBER"
      labelClassName="text-xs"
      name="rc_number"
      value={data.rc_number}
      // onBlur={onSubmit}
      onRightIconClick={onSubmit}
      placeholder="RC-8829103"
      required={true}
      status={error}
      loading={loading}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        dataSet((prev) => ({ ...prev, rc_number: e.target.value }));
        errorSet("");
      }}
      right_icon={<FaArrowRightLong />}
      customBgColor="bg-white"
    />
  );
};

export default GetRCNumber;
